import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { CategoryStoreGroupPayload, CategoryStoreGroupResponse } from "@/types/interface/category-store-group";

export const useCategoryGroupStore = defineStore("categoryGroup", () => {
  const categoryGroup = ref<CategoryStoreGroupResponse>();
  const categoryGroups = ref<CategoryStoreGroupResponse[]>([]);

  function initCategoryGroups(data: any) {
    categoryGroups.value = data?.data;
  }

  function addNewCategoryGroup(data: any) {
    categoryGroup.value = data;
  }

  async function dispatchGetCategoryGroups(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryGroup.getCategoryGroup(page, limit, queryParam);
      if (status === 200 ) {
        initCategoryGroups(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idCategoryGroup = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryGroup.findCategoryGroup(idCategoryGroup);
      if (status === 200 ) {
        addNewCategoryGroup(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: CategoryStoreGroupPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryGroup.createCategoryGroup(payload);
      if (status === 200 ) {
        addNewCategoryGroup(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idCategoryGroup = "", payload: CategoryStoreGroupPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryGroup.updateCategoryGroup(idCategoryGroup, payload);
      if (status === 200 ) {
        addNewCategoryGroup(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idCategoryGroup = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryGroup.deleteCategoryGroup(idCategoryGroup);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    categoryGroup,
    categoryGroups,
    initCategoryGroups,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetCategoryGroups,
    dispatchDelete
  };
});